var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("keep-alive", [
    _c("div", { staticClass: "modal-mask" }, [
      _c("div", { staticClass: "modal-wrapper" }, [
        _c("div", { staticClass: "modal_size sm_size" }, [
          _c(
            "a",
            {
              staticClass: "ui_close",
              attrs: { href: "JavaScript:", type: "button" },
              on: {
                click: function($event) {
                  return _vm.$emit("close")
                }
              }
            },
            [_c("span", { staticClass: "sr_only" }, [_vm._v("popup close")])]
          ),
          _vm._v(" "),
          _c("dl", { staticClass: "modal_content" }, [
            _c("dt", { staticClass: "ellipsis" }, [
              _c("i", [_vm._v(_vm._s(_vm.$t("TITLE.POPUP.SELECT.ROLE")))])
            ]),
            _vm._v(" "),
            _c("dd", [
              _c("div", { staticClass: "grid_wrap mt10" }, [
                _c("table", { staticClass: "scroll_table" }, [
                  _c("colgroup", [
                    _c("col", { attrs: { width: "15%" } }),
                    _vm._v(" "),
                    _c("col", { attrs: { width: "35%" } }),
                    _vm._v(" "),
                    _c("col", { attrs: { width: "*" } })
                  ]),
                  _vm._v(" "),
                  _c("thead", [
                    _c("tr", [
                      _c("th", { staticClass: "tC", attrs: { width: "15%" } }, [
                        _vm._v(_vm._s(_vm.$t("FIELD.GLOVAL.CHECK")))
                      ]),
                      _vm._v(" "),
                      _c("th", { staticClass: "tC", attrs: { width: "35%" } }, [
                        _vm._v(_vm._s(_vm.$t("FIELD.ROLE.CODE")))
                      ]),
                      _vm._v(" "),
                      _c("th", { staticClass: "tC", attrs: { width: "*" } }, [
                        _vm._v(_vm._s(_vm.$t("FIELD.ROLE.NAME")))
                      ])
                    ])
                  ]),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    { staticClass: "text_center" },
                    _vm._l(_vm.authRoles, function(auth) {
                      return _c("tr", { key: auth.AUTHCORPID }, [
                        _c(
                          "td",
                          { staticClass: "tC", attrs: { width: "15%" } },
                          [
                            _c("label", { staticClass: "radiobox-wrap" }, [
                              _c("input", {
                                directives: [
                                  {
                                    name: "model",
                                    rawName: "v-model",
                                    value: auth.selected,
                                    expression: "auth.selected"
                                  }
                                ],
                                attrs: { type: "radio", name: "selAuth" },
                                domProps: {
                                  checked: _vm._q(auth.selected, null)
                                },
                                on: {
                                  change: [
                                    function($event) {
                                      return _vm.$set(auth, "selected", null)
                                    },
                                    function($event) {
                                      return _vm.selectRowChk(auth)
                                    }
                                  ]
                                }
                              }),
                              _vm._v(" "),
                              _c("i", { staticClass: "radio-icon" })
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c("td", { attrs: { width: "35%" } }, [
                          _vm._v(_vm._s(auth.AUTHID))
                        ]),
                        _vm._v(" "),
                        _c("td", { attrs: { width: "*" } }, [
                          _vm._v(_vm._s(auth.AUTHNM))
                        ])
                      ])
                    }),
                    0
                  )
                ])
              ]),
              _vm._v(" "),
              _c("table", { staticClass: "create_table mt20" }, [
                _c("colgroup", [
                  _c("col", { attrs: { width: "35%" } }),
                  _vm._v(" "),
                  _c("col", { attrs: { width: "*" } })
                ]),
                _vm._v(" "),
                _c("tbody", [
                  _c("tr", [
                    _c("th", [_vm._v(_vm._s(_vm.$t("FIELD.AUTHREQ.AUTH")))]),
                    _vm._v(" "),
                    _c("td", [
                      _c("label", { staticClass: "radiobox-wrap " }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.creationYn,
                              expression: "creationYn"
                            }
                          ],
                          attrs: {
                            type: "radio",
                            name: "creation",
                            value: "N",
                            checked: ""
                          },
                          domProps: { checked: _vm._q(_vm.creationYn, "N") },
                          on: {
                            change: function($event) {
                              _vm.creationYn = "N"
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("i", { staticClass: "radio-icon" }),
                        _vm._v(" "),
                        _c("em", [
                          _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.ONLY.VIEW")))
                        ])
                      ]),
                      _vm._v(" "),
                      _c("label", { staticClass: "radiobox-wrap" }, [
                        _c("input", {
                          directives: [
                            {
                              name: "model",
                              rawName: "v-model",
                              value: _vm.creationYn,
                              expression: "creationYn"
                            }
                          ],
                          attrs: {
                            type: "radio",
                            name: "creation",
                            value: "Y"
                          },
                          domProps: { checked: _vm._q(_vm.creationYn, "Y") },
                          on: {
                            change: function($event) {
                              _vm.creationYn = "Y"
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("i", { staticClass: "radio-icon" }),
                        _vm._v(" "),
                        _c("em", [
                          _vm._v(_vm._s(_vm.$t("FIELD.GLOBAL.CREATION")))
                        ])
                      ])
                    ])
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "div",
                {
                  staticClass: "btn_modal_wrap topLine",
                  staticStyle: {
                    padding: "10px 1px 1px 1px",
                    margin: "5px 0px 1px 0px"
                  }
                },
                [
                  _c("div", { staticClass: "btn_right" }, [
                    _c(
                      "a",
                      {
                        staticClass: "btn_white",
                        attrs: { href: "JavaScript:", title: "" },
                        on: {
                          click: function($event) {
                            return _vm.$emit("close")
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.CANCEL")))]
                    ),
                    _vm._v(" "),
                    _c(
                      "a",
                      {
                        staticClass: "btn_blue",
                        attrs: { href: "JavaScript:", title: "" },
                        on: {
                          click: function($event) {
                            return _vm.authSave()
                          }
                        }
                      },
                      [_vm._v(_vm._s(_vm.$t("BUTTON.GLOBAL.SELECT")))]
                    )
                  ])
                ]
              )
            ])
          ])
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2845429e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2845429e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/skpComponents/view/admin/system/menu/RoleAddPopup.vue
// module id = dW7r
// module chunks = 0